import { connect } from 'react-redux';
import { isFunction } from 'lodash';
import { logout } from '../../../screens/Login/actions';
import { resetMonitorView } from '../../../screens/PlazaView/actions';
import { resetToInitialState } from '../../../screens/PlazaView/components/Editor/actions';
import Navbar from './Navbar';

const mapStateToProps = (state) => ({
  isAuthenticated: state.login.isAuthenticated,
  user: state.login.user,
  config: state.appConfig.config,
  logoutBlockers: state.login.logoutBlockers,
});

const mapDispatchToProps = (dispatch) => ({
  logout: async (blockers) => {
    if (blockers && blockers.length > 0) {
      let shouldBlock = false;
      const reversedBlockers = [...blockers].reverse().filter((blocker) => isFunction(blocker));

      for (const blocker of reversedBlockers) {
        // eslint-disable-next-line no-await-in-loop
        const res = await blocker();
        if (res) {
          shouldBlock = true;
          break;
        }
      }

      if (shouldBlock) {
        return;
      }
    }
    dispatch(resetToInitialState());
    dispatch(resetMonitorView());
    dispatch(logout());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
